/**
 * Canonical public site URL for SEO artifacts (canonical links, og:url,
 * JSON-LD ids, sitemap <loc>). Always the live domain regardless of build
 * environment, so non-production builds never advertise themselves as
 * canonical.
 *
 * Must NOT import from files that use `@/` aliases, because
 * `react-router.config.ts` loads it in plain Node via `sitemap.ts`.
 */
const SITE_URL = "https://baana.nettiauto.com";

const toCanonicalUrl = (path: string): string => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalizedPath}`;
};

export { SITE_URL, toCanonicalUrl };
